import "antd/es/modal/style";
import _Modal from "antd/es/modal";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import classNames from 'classnames';
import { IconCloseOutlined, IconCheckCircleFilled, IconCloseCircleFilled, IconInfoCircleFilled, IconExclamationCircleFilled } from '@osui/icons';
import Button from '@osui/button';
import useOsuiModal from './useModal';
import './index.less';
var destroyAll = _Modal.destroyAll,
    config = _Modal.config;

var getModalSize = function getModalSize(size) {
  if (typeof size === 'number') {
    return size;
  }

  switch (size) {
    case 'small':
      return 400;

    case 'default':
      return 600;

    case 'large':
      return 800;

    default:
      return 600;
  }
};

var clsPrefix = 'osui-modal';

var OriginModal = function OriginModal(_a) {
  var _classNames;

  var _b;

  var className = _a.className,
      bodyBorder = _a.bodyBorder,
      size = _a.size,
      props = __rest(_a, ["className", "bodyBorder", "size"]);

  var _props$okText = props.okText,
      okText = _props$okText === void 0 ? '确定' : _props$okText,
      okType = props.okType,
      _props$cancelText = props.cancelText,
      cancelText = _props$cancelText === void 0 ? '取消' : _props$cancelText,
      onOk = props.onOk,
      onCancel = props.onCancel,
      confirmLoading = props.confirmLoading,
      okButtonProps = props.okButtonProps,
      cancelButtonProps = props.cancelButtonProps,
      _props$autoHeight = props.autoHeight,
      autoHeight = _props$autoHeight === void 0 ? false : _props$autoHeight,
      centered = props.centered,
      widthProp = props.width,
      fullScreen = props.fullScreen;
  var width = getModalSize(size);
  var classes = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-auto-height"), autoHeight), _defineProperty(_classNames, "".concat(clsPrefix, "-body-border"), bodyBorder), _defineProperty(_classNames, "".concat(clsPrefix, "-full-screen"), fullScreen), _classNames), className);
  var footerStyle = React.useMemo(function () {
    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    };
  }, []);
  var footer = /*#__PURE__*/React.createElement("div", {
    style: footerStyle
  }, /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: onCancel
  }, cancelButtonProps), cancelText), /*#__PURE__*/React.createElement(Button, Object.assign({
    type: (_b = okType) !== null && _b !== void 0 ? _b : 'primary',
    onClick: onOk,
    loading: confirmLoading
  }, okButtonProps), okText));
  var innerCentered = centered !== null && centered !== void 0 ? centered : true;
  return /*#__PURE__*/React.createElement(_Modal, Object.assign({
    className: classNames(classes),
    closeIcon: /*#__PURE__*/React.createElement(IconCloseOutlined, null),
    footer: footer,
    width: widthProp !== null && widthProp !== void 0 ? widthProp : width,
    centered: innerCentered
  }, props));
};

OriginModal.useModal = useOsuiModal;
var Modal = OriginModal; // ======= Confirm ======

var confirmIconMap = {
  info: /*#__PURE__*/React.createElement(IconInfoCircleFilled, null),
  warning: /*#__PURE__*/React.createElement(IconExclamationCircleFilled, null),
  confirm: /*#__PURE__*/React.createElement(IconExclamationCircleFilled, null),
  error: /*#__PURE__*/React.createElement(IconCloseCircleFilled, null),
  success: /*#__PURE__*/React.createElement(IconCheckCircleFilled, null)
};

var getConfirmConfig = function getConfirmConfig(_a, type) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 'small' : _a$size,
      width = _a.width,
      okText = _a.okText,
      cancelText = _a.cancelText,
      okButtonProps = _a.okButtonProps,
      cancelButtonProps = _a.cancelButtonProps,
      closeIcon = _a.closeIcon,
      config = __rest(_a, ["size", "width", "okText", "cancelText", "okButtonProps", "cancelButtonProps", "closeIcon"]);

  var baseConfig = config; // 对confirm图表的样式调整处理

  Object.assign(baseConfig, {
    icon: config.hasOwnProperty('icon') ? config.icon : confirmIconMap[type]
  });
  return Object.assign(Object.assign({}, baseConfig), {
    width: width !== null && width !== void 0 ? width : getModalSize(size),
    okText: okText !== null && okText !== void 0 ? okText : '确定',
    cancelText: cancelText !== null && cancelText !== void 0 ? cancelText : '取消',
    closable: Boolean(config.title && config.closable),
    closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : /*#__PURE__*/React.createElement(IconCloseOutlined, null),
    okButtonProps: Object.assign(Object.assign({}, okButtonProps), {
      className: classNames(okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.className, 'osui-button', 'osui-button-min-width')
    }),
    cancelButtonProps: Object.assign(Object.assign({}, cancelButtonProps), {
      className: classNames(okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.className, 'osui-button', 'osui-button-min-width')
    }),
    className: classNames("".concat(clsPrefix, "-confirm"), config.className)
  });
};

Modal.info = function (config) {
  return _Modal.info(getConfirmConfig(config, 'info'));
};

Modal.warning = function (config) {
  return _Modal.warning(getConfirmConfig(config, 'warning'));
};

Modal.warn = Modal.warning;

Modal.error = function (config) {
  return _Modal.error(getConfirmConfig(config, 'error'));
};

Modal.success = function (config) {
  return _Modal.success(getConfirmConfig(config, 'success'));
};

Modal.confirm = function (config) {
  return _Modal.confirm(getConfirmConfig(config, 'confirm'));
};

Modal.destroyAll = destroyAll;
Modal.config = config;
export default Modal;
//# sourceMappingURL=index.js.map